import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Stack, Button, Typography, Box, Tabs, Tab } from '@mui/material';
// Tabela
import { getAnyRoute } from './api';
import RelatorioData from './RelatorioData';
import RelatorioDataDetailed from './RelatorioDataDetailed';
import RelatorioComissao from './RelatorioComissao';
import RelatorioPropostas from './RelatorioPropostas';
import RelatorioIndicacoes from './RelatorioIndicacoes';
import RelatorioRejeitadas from './RelatorioRejeitadas';
import RelatorioRejeitadasCpfCnpj from './RelatorioRejeitadasCpfCnpj';
import RelatorioDespesas from './RelatorioDespesas';
import RelatorioOrcamentosServico from './RelatorioOrcamentosServico';
import RelatorioVendasServico from './RelatorioVendasServico';
import RelatorioCustosServico from './RelatorioCustosServico';
import RelatorioRejeitadasServico from './RelatorioRejeitadasServico';
import RelatorioComissaoServico from './RelatorioComissaoServico';
import RelatorioIndicacoesServico from './RelatorioIndicacoesServico';
import { cores } from '../styles/styleUtils';

const styleButton = {
  width: 200,
};

// ------------------------------------------------------------------------

export default function Relatorios() {
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  const emptyFiltro = {
    datainicial: primeiroDiaDoMes,
    datafinal: ultimoDiaDoMes,
  };

  const [data, setData] = useState(null);
  const [campos, setCampos] = useState(null);
  const [filtro, setFiltro] = useState(emptyFiltro);
  const [type, setType] = useState('');
  const [despesaModo, setDespesaModo] = useState('obras');
  const [categoria, setCategoria] = useState('produtos'); // 'produtos' | 'servicos'

  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  const isSupervisor  = usuarioLogado?.supervisor === true;

  const getData = async () => {
    if (type === 'vendas') {
      const result = await getAnyRoute('relatorios/vendas-detalhado', filtro);
      setData(result);
    }
    if (type === 'propostas') {
      const result = await getAnyRoute('relatorios/propostas', filtro);
      setData(result);
    }
    if (type === 'orcamentosServico') {
      const result = await getAnyRoute('relatorios/servicos/orcamentos', filtro);
      setData(result);
    }
    if (type === 'vendasServico') {
      const result = await getAnyRoute('relatorios/servicos/vendas', filtro);
      setData(result);
    }
    if (type === 'custosServico') {
      const result = await getAnyRoute('relatorios/servicos/custos', filtro);
      setData(result);
    }
    if (type === 'rejeitadasServico') {
      const result = await getAnyRoute('relatorios/servicos/rejeitadas', filtro);
      setData(result);
    }
    if (type === 'comissoesServico') {
      const result = await getAnyRoute('relatorios/servicos/comissao', filtro);
      setData(result);
    }
    if (type === 'indicacoesServico') {
      const result = await getAnyRoute('relatorios/servicos/indicacoes', filtro);
      setData(result);
    }
    if (type === 'comissoes') {
      const result = await getAnyRoute('relatorios/comissao', filtro);
      setData(result);
    }
    if (type === 'indicacoes') {
      const result = await getAnyRoute('relatorios/indicacoes', filtro);
      setData(result);
    }
    if (type === 'rejeitadas' || type === 'rejeitadasCpfCnpj') {
      const result = await getAnyRoute('relatorios/rejeitadas', filtro);
      setData(result);
    }
    if (type === 'despesas') {
      const rota = despesaModo === 'operacionais'
        ? 'relatorios/despesas-operacionais'
        : 'relatorios/despesas-obras';
      const result = await getAnyRoute(rota, filtro);
      setData(result);
    }

    if (type === 'estoque') {
      const result = await getAnyRoute('relatorios/estoque', filtro);
      setData(result.dados);
      setCampos(result.campos);
    }
  };

  useEffect(() => {
    getData();
  }, [type, filtro, despesaModo]);

  const changeType = (newType) => {
    if (type === newType) return;
    setData(null);
    setCampos(null);
    setFiltro(emptyFiltro); // Reset filtro when changing report type
    setDespesaModo('obras'); // Sempre começa em Obras ao abrir Despesas
    setType(newType);
  };

  const onLimparFiltro = () => {
    setFiltro(emptyFiltro);
  };

  const changeCategoria = (novaCategoria) => {
    if (categoria === novaCategoria) return;
    setData(null);
    setCampos(null);
    setFiltro(emptyFiltro);
    setType('');
    setCategoria(novaCategoria);
  };

  // ----------------------

  return (
    <>
      <Helmet>
        <title> Relatórios </title>
      </Helmet>
      <Typography variant="h4" sx={{ mb: 5 }}>
        Relatórios
      </Typography>
      <Container maxWidth="xl">
        <Tabs
          value={categoria}
          onChange={(e, v) => changeCategoria(v)}
          TabIndicatorProps={{ sx: { backgroundColor: cores.laranja, height: 3 } }}
          sx={{
            mb: 3,
            borderBottom: '1px solid #E0E0E0',
            '& .MuiTab-root': { fontWeight: 600, color: '#666' },
            '& .MuiTab-root.Mui-selected': { color: cores.laranja },
          }}
        >
          <Tab value="produtos" label="Produtos" />
          <Tab value="servicos" label="Serviços" />
        </Tabs>

        {categoria === 'produtos' && (
          <Stack gap={2} direction={'row'} flexWrap="wrap">
            <Button
              onClick={() => changeType('vendas')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'vendas' ? 'green' : undefined }}
            >
              Vendas
            </Button>
            <Button
              onClick={() => changeType('propostas')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'propostas' ? 'green' : undefined }}
            >
              Propostas
            </Button>
            <Button
              onClick={() => changeType('comissoes')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'comissoes' ? 'green' : undefined }}
            >
              Comissões
            </Button>
            <Button
              onClick={() => changeType('indicacoes')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'indicacoes' ? 'green' : undefined }}
            >
              Indicações
            </Button>
            <Button
              onClick={() => changeType('rejeitadas')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'rejeitadas' ? 'green' : undefined }}
            >
              Rejeitadas
            </Button>
            <Button
              onClick={() => changeType('rejeitadasCpfCnpj')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'rejeitadasCpfCnpj' ? 'green' : undefined }}
            >
              CPF/CNPJ Reprovados
            </Button>
            <Button
              onClick={() => changeType('despesas')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'despesas' ? 'green' : undefined }}
            >
              Despesas
            </Button>
            <Button
              onClick={() => changeType('estoque')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'estoque' ? 'green' : undefined }}
            >
              Estoque
            </Button>
          </Stack>
        )}

        {categoria === 'servicos' && (
          <Stack gap={2} direction={'row'} flexWrap="wrap">
            <Button
              onClick={() => changeType('orcamentosServico')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'orcamentosServico' ? 'green' : undefined }}
            >
              Orçamentos Realizados
            </Button>
            <Button
              onClick={() => changeType('vendasServico')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'vendasServico' ? 'green' : undefined }}
            >
              Vendas Realizadas
            </Button>
            <Button
              onClick={() => changeType('custosServico')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'custosServico' ? 'green' : undefined }}
            >
              Custos Por Serviço
            </Button>
            <Button
              onClick={() => changeType('rejeitadasServico')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'rejeitadasServico' ? 'green' : undefined }}
            >
              Reprovados
            </Button>
            <Button
              onClick={() => changeType('comissoesServico')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'comissoesServico' ? 'green' : undefined }}
            >
              Comissões
            </Button>
            <Button
              onClick={() => changeType('indicacoesServico')}
              variant="contained"
              sx={{ ...styleButton, backgroundColor: type === 'indicacoesServico' ? 'green' : undefined }}
            >
              Indicações
            </Button>
          </Stack>
        )}
      </Container>
      {type === 'vendas' && data && (
        <RelatorioDataDetailed
          data={data}
          type={type}
          filtro={filtro}
          setFiltro={setFiltro}
          onLimpar={onLimparFiltro}
        />
      )}
      {type === 'comissoes' && data && (
        <RelatorioComissao data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} />
      )}
      {type === 'propostas' && data && (
        <RelatorioPropostas data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} />
      )}
      {type === 'orcamentosServico' && data && (
        <RelatorioOrcamentosServico data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} />
      )}
      {type === 'vendasServico' && data && (
        <RelatorioVendasServico data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} />
      )}
      {type === 'custosServico' && data && (
        <RelatorioCustosServico data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} />
      )}
      {type === 'rejeitadasServico' && data && (
        <RelatorioRejeitadasServico data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} isSupervisor={isSupervisor} />
      )}
      {type === 'comissoesServico' && data && (
        <RelatorioComissaoServico data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} />
      )}
      {type === 'indicacoesServico' && data && (
        <RelatorioIndicacoesServico data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} />
      )}
      {type === 'indicacoes' && data && (
        <RelatorioIndicacoes data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} />
      )}
      {type === 'rejeitadas' && data && (
        <RelatorioRejeitadas data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} isSupervisor={isSupervisor} />
      )}
      {type === 'rejeitadasCpfCnpj' && data && (
        <RelatorioRejeitadasCpfCnpj data={data} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} isSupervisor={isSupervisor} />
      )}
      {type === 'despesas' && (
        <Box sx={{ mt: 3 }}>
          <Tabs
            value={despesaModo}
            onChange={(e, v) => { setData(null); setDespesaModo(v); }}
            TabIndicatorProps={{ sx: { backgroundColor: cores.laranja, height: 3 } }}
            sx={{
              borderBottom: '1px solid #E0E0E0',
              '& .MuiTab-root': { fontWeight: 600, color: '#666' },
              '& .MuiTab-root.Mui-selected': { color: cores.laranja },
            }}
          >
            <Tab value="obras" label="Obras" />
            <Tab value="operacionais" label="Operacionais" />
          </Tabs>
          {data && (
            <RelatorioDespesas
              data={data}
              modo={despesaModo}
              type={type}
              filtro={filtro}
              setFiltro={setFiltro}
              onLimpar={onLimparFiltro}
            />
          )}
        </Box>
      )}
      {type === 'estoque' && data && (
        <RelatorioData data={data} campos={campos} type={type} filtro={filtro} setFiltro={setFiltro} onLimpar={onLimparFiltro} />
      )}
      
      
    </>
  );
}